import { render } from "./selectPatient.vue?vue&type=template&id=13019dd4&scoped=true"
import script from "./selectPatient.vue?vue&type=script&lang=js"
export * from "./selectPatient.vue?vue&type=script&lang=js"

import "./selectPatient.vue?vue&type=style&index=0&id=13019dd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13019dd4"]])

export default __exports__